export default "__VITE_ASSET__CVOAYCwa__"